/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import APIManager from "../../ApiManager/ApiManager";
import {
  FETCH_OEM_ADMIN_ECU_REQUEST,
  FETCH_OEM_ADMIN_ECU_SUCCESS,
  FETCH_OEM_ADMIN_ECU_FAILURE,
} from "./OemAdminEcuTypes";
import { COMMON_ERROR } from "../ApplicationDetailsError/ApplicationDetailsErrorTypes";

export const fetchOemAdminEcuRequest = () => {
  return {
    type: FETCH_OEM_ADMIN_ECU_REQUEST,
  };
};

export const fetchOemAdminEcuSuccess = (EcuData) => {
  return {
    type: FETCH_OEM_ADMIN_ECU_SUCCESS,
    payload: EcuData,
  };
};

export const fetchOemAdminEcuFailure = (error) => {
  return {
    type: FETCH_OEM_ADMIN_ECU_FAILURE,
    payload: error,
  };
};

export const fetchOemAdminEcuDetails = () => {
  return async function (dispatch) {
    dispatch(fetchOemAdminEcuRequest());
    try {
      const data = await APIManager.getEcuTypes();
      dispatch(fetchOemAdminEcuSuccess(data));
    } catch (error) {
      dispatch(fetchOemAdminEcuFailure(error));
      dispatch(commonError(error, FETCH_OEM_ADMIN_ECU_FAILURE));
    }
  };
};

export const commonError=(error,errorType)=>{
  return({
    type:COMMON_ERROR,
    payload:{
      message:error.message,
      errorType:errorType
    }
  })
}
